import { Tag, Task, Team } from '@bringg/types';

export type DemoSettingsField = {
  name: string;
  component: string;
  label: string;
  value: any;
  options?: any[];
  isAllFilteredOut?: boolean;
  optionLabel?: string;
};

export type DemoSettings = {
  name: string;
  demoType: DemoFlows;
  description: string;
  demoIncludes: string[];
  fields: DemoSettingsField[];
  createTask: (...args: any[]) => Promise<Task>;
};

export enum DemoFlows {
  ECommerce = 0,
  InternalDriver = 1,
}

export type ECommerceSettings = {
  phone: string;
  sleepBetweenTasksStatusCreation: number;
  assignDriverIntervalSeconds: number;
  shouldGenerateBackgroundTasks: boolean;
  checkInPickupIntervalSeconds: number;
  checkOutPickupIntervalSeconds: number;
  checkInDropOffIntervalSeconds: number;
  checkOutDropOffIntervalSeconds: number;
  finishOrder: number;
  ordersToBeCreated: number;
  team: Team;
  tag: Tag;
};
